import type { FC } from "react"

import { useMarkAsNotReceived } from "../hooks"

import { ConfirmationDialog } from "@/components/common/Modals"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface MarkAsNotReceivedConfirmationProps {
  goodsReceipt: GoodsReceipt
  onClose: () => void
  onSuccess?: () => void
}

export const MarkAsNotReceivedConfirmation: FC<MarkAsNotReceivedConfirmationProps> = ({
  goodsReceipt,
  onClose,
  onSuccess,
}) => {
  const { markAsNotReceived } = useMarkAsNotReceived(onSuccess)

  const handleConfirmMarkAsNotReceived = async (): Promise<void> => {
    await markAsNotReceived(goodsReceipt)
    onClose()
  }

  return (
    <ConfirmationDialog
      title='Warning: You are about to mark this item as not received'
      content='Do you wish to continue?'
      closeLabel='Cancel'
      confirmLabel='Proceed To Mark As Not Received'
      onClose={onClose}
      onConfirm={handleConfirmMarkAsNotReceived}
      isWarning
    />
  )
}
